// extracted by mini-css-extract-plugin
module.exports = {"w926ko4":"w926ko4"};